import fiLocale from 'date-fns/locale/fi'

const fi = 'fi-FI'

export const DateFnsLocales = {
  [fi]: fiLocale
}

export const APP_LOCALE = fi
